import { getEditLocation } from "../../../core/util/functions";

export const currencyRateLocation = "/listing/codebook/currencyrates";
export const getCurrencyRateEditLocation = (id?: number | string) =>
	getEditLocation(currencyRateLocation, undefined, id?.toString());

export const editRouter = getCurrencyRateEditLocation(":rateId?");
